import { Services } from '@sigma-frontend-libs/commons'
import { RECURRENT_PAYMENTS_TYPES } from '@sigma-legacy-libs/essentials/lib/constants'
import { TaskFrequency } from '@sigmasms/shared-types'

import { proxy } from '@/utils'

import render from './render'

export default {
  name: 'RecurrentPaymentsForm',

  mixins: [ proxy({ type: 'object' }) ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isNew: {
      type: Boolean,
      default: false
    },

    OwnerId: String
  },

  data() {
    return {
      formValidation: false
    }
  },

  computed: {
    types() {
      return RECURRENT_PAYMENTS_TYPES.map(type => {
        return {
          value: type,
          label: this.getTranslate(`${Services.recurrentPayments}.types.${type}`)
        }
      })
    },

    frequencyItems() {
      return Object.values(TaskFrequency).reduce((frequencies, frequency) => {
        if (![ TaskFrequency.once ].includes(frequency)) {
          frequencies.push({
            title: this.getTranslate(`${Services.tasks}.frequencies.${frequency}`),
            value: frequency
          })
        }

        return frequencies
      }, [])
    },

    validation() {
      let result = true

      if (!this.formValidation) {
        result = false
      }

      if (!this.proxy.method) {
        result = false
      }

      if (!this.proxy.amount || this.proxy.amount <= 0 || this.localErrors.amount) {
        result = false
      }

      if (this.proxy.type) {
        switch (this.proxy.type) {
          case RECURRENT_PAYMENTS_TYPES.threshold: {
            if (this.localErrors.threshold) {
              result = false
            }
            break
          }
          case RECURRENT_PAYMENTS_TYPES.frequency: {
            if (!this.proxy.frequency || !Object.values(TaskFrequency).includes(this.proxy.frequency)) {
              result = false
            }
            break
          }
        }
      } else {
        result = false
      }

      return result
    },

    localErrors() {
      const errors = {}
      const amount = parseFloat(this.proxy.amount)
      const threshold = parseFloat(this.proxy.threshold)
      if (isNaN(amount)) {
        errors.amount = this.getTranslate(`${Services.recurrentPayments}.errors.amount.required`)
      } else {
        if (amount <= 0) {
          errors.amount = this.getTranslate(`${Services.recurrentPayments}.errors.amount.min`)
        }
      }
      if (isNaN(threshold)) {
        errors.threshold = this.getTranslate(`${Services.recurrentPayments}.errors.threshold.required`)
      } else {
        if (threshold <= 0) {
          errors.threshold = this.getTranslate(`${Services.recurrentPayments}.errors.threshold.min`)
        }
      }

      return errors
    }
  },

  watch: {
    validation() {
      this.$emit('validation', this.validation)
    },

    'proxy.type'() {
      this.proxy.threshold = undefined
      this.proxy.frequency = undefined
    }
  },

  mounted() {
    this.proxy.type = RECURRENT_PAYMENTS_TYPES[0]
    this.$emit('validation', this.validation)
  },

  render
}
